<script>
  import {cn} from "$lib/utils.js";
  import GridBody from "./bits/calendar-grid-body.svelte";

  let {ref = $bindable(null), class: className, ...restProps} = $props();
</script>

<GridBody bind:ref class={cn(className)} {...restProps}/>
